import React from 'react';
import { TablePagination } from '@material-ui/core';

export const PAGE_SIZE_OPTIONS = [25, 50, 100];

interface CommunicationsPaginationProps {
  total: number;
  offset: number;
  pageSize: number;
  onOffsetChange: (offset: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

/**
 * The same MUI TablePagination the volunteer database and applications tabs render through
 * GridPagination, so the footer reads identically across the app.
 */
export const CommunicationsPagination = ({
  total,
  offset,
  pageSize,
  onOffsetChange,
  onPageSizeChange,
}: CommunicationsPaginationProps) => (
  <TablePagination
    component='div'
    style={{ flex: '0 0 auto', borderTop: '1px solid #EFEFEF' }}
    count={total}
    page={pageSize > 0 ? Math.floor(offset / pageSize) : 0}
    rowsPerPage={pageSize}
    rowsPerPageOptions={PAGE_SIZE_OPTIONS}
    onChangePage={(_unusedEvent, page) => onOffsetChange(page * pageSize)}
    onChangeRowsPerPage={(e) => {
      onPageSizeChange(parseInt(e.target.value, 10));
      onOffsetChange(0);
    }}
  />
);
